'use client';

import { Indices, getIndex } from '@av/algolia';
import type { MultipleQueriesResponse } from '@av/algolia';
import { InstantSearchNext } from 'react-instantsearch-nextjs';
import algoliasearch from 'algoliasearch/lite';
import { SearchProductResponse } from '@av/algolia';
import { useMemo } from 'react';

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID!,
  process.env.NEXT_PUBLIC_ALGOLIA_READ_API_KEY!
);

export default function SearchClient({
  children,
  cachedResults,
}: {
  children: React.ReactNode;
  cachedResults?: SearchProductResponse;
}) {
  const querySearchClient = useMemo(
    () => ({
      ...searchClient,
      search: async function (requests) {
        if (cachedResults && requests[0].page === 0) {
          return { results: [cachedResults] } as MultipleQueriesResponse<any>;
        } else {
          return searchClient.search<any>(requests);
        }
      },
    }),
    [cachedResults]
  );

  return (
    <InstantSearchNext
      searchClient={querySearchClient}
      indexName={getIndex(Indices.PRODUCTS)}
      future={{ preserveSharedStateOnUnmount: false }}
    >
      {children}
    </InstantSearchNext>
  );
}
